//import logo from "./logo.svg";
//import "./App.css";
//import { Testing } from "./Testing";
import { BrowserRouter } from "react-router-dom";
import "rsuite/dist/rsuite.min.css";
import AppRoutes from "./AppRoutes";

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
